import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FontStyle extends BaseOption {
  static userInterfaceComponent = {
    label: "Italic",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "italic",
          tooltip: "",
        },
        {
          label: "No",
          value: "none",
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = "none";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "normal") {
      return "none";
    }
    return configValue;
  }
}
